module.exports = __webpack_public_path__ + "saira.png?33b7b51eec59d9dce00ef7a5535575ee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/saira.png
// module id = 176
// module chunks = 0